const defaultBoxes = [];
const boxesList = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'EPIK_BOXES_CLEAR':
      return defaultBoxes;
    case 'EPIK_BOXES_LIST_SUCCESS':
      return action.boxesList;
    default:
      return state;
  }
};

export default boxesList;
